import { css } from '@/styled-system/css';

export const feeSection = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'tighter',
});

export const feeSectionTitle = css({
  fontSize: 'heading-xs',
  fontWeight: 'bold',
  color: 'text.neutral',
  margin: 0,
});

export const feeContent = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'tighter',
});

export const feeItem = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'tighter',
});

export const feeAdjustmentControls = css({
  display: 'flex',
  flexWrap: 'wrap',
  gap: 'tighter',
});

export const feeGroupLabel = css({
  fontSize: 'body-sm',
  lineHeight: 'body-sm',
  fontWeight: 'bold',
  color: 'text.neutral',
});

export const feeRow = css({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  gap: 'default',
  fontSize: 'body-sm',
  lineHeight: 'body-sm',
});

export const feeLabel = css({
  flex: '1 1 auto',
  minWidth: 0,
  color: 'text.subtle',
});

export const feeValue = css({
  flexShrink: 0,
  fontWeight: 'bold',
  color: 'text.neutral',
  textAlign: 'right',
});

export const optionalFeeRow = css({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: 'default',
  fontSize: 'body-sm',
  lineHeight: 'body-sm',
});

export const optionalFeeControl = css({
  flex: '1 1 auto',
  minWidth: 0,
  // LabeledControl's public props don't expose a compact checkbox label size.
  // Keep the primitive and narrow this row-only label back to fee-row text.
  '& > [data-c11n-component="Label"]': {
    fontSize: 'body-sm',
    lineHeight: 'body-sm',
    fontWeight: 'regular',
    color: 'text.subtle',
  },
});

export const feeTotalRow = css({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  gap: 'default',
  fontSize: 'body-sm',
  lineHeight: 'body-sm',
  fontWeight: 'bold',
  color: 'text.accent.brand.hero',
  paddingTop: 'tighter',
  borderTopWidth: 'default',
  borderTopStyle: 'solid',
  borderTopColor: 'border.neutral',
  marginTop: 'tighter',
});
